const MuiTab = {
  disableRipple: true
};
export default MuiTab;